import Vue from 'vue'
import db from './data'
import user from './user'
import place from './place.js'
import company from './company.js'

// 操作浏览器缓存
Vue.prototype.$db = db
Vue.prototype.$user = user
Vue.prototype.$company = company
Vue.prototype.$place = place
// 常用工具类
export default {
    db,user,company,place
}



// WEBPACK FOOTER //
// ./src/utils/index.js